import AEMWrapper from "aem/ComponentWrapper";
import React from "react";
import meta from "./aem-meta";
import loadable from "@loadable/component";
const RHRestaurantsMain = loadable(
  () => import(/* webpackChunkName: "component-rh-restaurants-main" */ "."),
  { fallback: <></> }
);

export default AEMWrapper(meta, RHRestaurantsMain);
